import { Play } from "@phosphor-icons/react";
import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const meditationPalette: FeaturePalette = {
  commands: [
    {
      id: "meditation.start",
      title: "Start meditation",
      icon: Play,
      scopeId: "meditation",
      keywords: ["meditate", "breathe", "calm"],
      run: (ctx) => ctx.router.push("/meditation"),
    },
  ],
};
